<h1 mat-dialog-title>
  @if (data.title) {
    <span>{{data.title}}</span>
  } @else {
    <span>Add Item</span>
  }
</h1>

<div mat-dialog-content>
  <mat-form-field>
    <mat-chip-grid #chipList aria-label="Item selection">
      @for (item of items; track item) {
        <mat-chip-row
          [editable]="selectable"
          [removable]="removable"
          (removed)="removeItem(item)"
          >
          {{ item.name }} ({{ item.tag }}) @if (removable) {
          <mat-icon matChipRemove>cancel</mat-icon>
        }
      </mat-chip-row>
    }
    <input
      #itemInput
      [attr.data-testid]="'add_item_text'"
      [disabled]="tagExists || isLoadingCommonItems"
      [formControl]="input"
      [matAutocomplete]="auto"
      [matChipInputFor]="chipList"
      matInput
      ngModel="input"
      [placeholder]="isLoadingCommonItems ? 'Loading common items...' : 'Start typing'"
      (paste)="onPaste($event)"
      />
  </mat-chip-grid>
</mat-form-field>
@if (tagExists) {
  <div class="mat-error">
    {{ errorMessage }}
  </div>
}
<mat-autocomplete
  #auto="matAutocomplete"
  autoActiveFirstOption="true"
  [displayWith]="displayFn"
  panelWidth="555px"
  (optionSelected)="itemSelected($event)"
  >
  @for (option of options; track option) {
    <mat-option
      [attr.data-testid]="option.name + '_option'"
      [value]="option"
    >{{ option.name }} ({{ option.tag }})</mat-option>
  }
</mat-autocomplete>
@if (displayAddGlobal) {
  <div class="toggle-question">
    <mat-slide-toggle
      [attr.data-testid]="'add_global_toggle'"
      [formControl]="addGlobal"
      ><span class="toggle-label">Add Global</span></mat-slide-toggle>
    </div>
  }
</div>
<div mat-dialog-actions>
  <button
    [attr.data-testid]="'cancel_button'"
    mat-raised-button
    matTooltip="Cancel"
    class="button-color"
    (click)="cancelAddItem()"
  >Cancel</button>
  <button
    [attr.data-testid]="'ok_button'"
    class="button-color"
    [disabled]="items.length === 0 || tagExists || (isReadOnly$ | async)"
    mat-raised-button
    matTooltip="Save"
    (click)="addItem()"
  >Ok</button>
</div>
